import React from "react";
import PropTypes from "prop-types";

export const LinkedIn = ({ color = "#0077B5" }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5734 1.85254H3.05716C2.392 1.85254 1.85156 2.40054 1.85156 3.07325V17.563C1.85156 18.2358 2.392 18.7838 3.05716 18.7838H17.5734C18.2386 18.7838 18.7828 18.2358 18.7828 17.563V3.07325C18.7828 2.40054 18.2386 1.85254 17.5734 1.85254ZM6.96872 16.365H4.45927V8.28489H6.9725V16.365H6.96872ZM5.714 7.18134C4.90901 7.18134 4.25897 6.52752 4.25897 5.72631C4.25897 4.9251 4.90901 4.27128 5.714 4.27128C6.51521 4.27128 7.16902 4.9251 7.16902 5.72631C7.16902 6.5313 6.51898 7.18134 5.714 7.18134ZM16.3754 16.365H13.8659V12.4345C13.8659 11.4973 13.847 10.2917 12.5621 10.2917C11.2544 10.2917 11.0541 11.3121 11.0541 12.3665V16.365H8.54468V8.28489H10.9521V9.38844H10.9861C11.3225 8.75352 12.1426 8.08459 13.3633 8.08459C15.903 8.08459 16.3754 9.75881 16.3754 11.9357V16.365Z"
        fill="white"
      />
    </svg>
  );
};
LinkedIn.propTypes = {
  color: PropTypes.string,
};
